import { ConfigStateService, PermissionService } from '@abp/ng.core';
import { Component, OnInit } from '@angular/core';
import { FeatureConstants } from 'src/core/constants/feature-constant';
import { PermissionConstants } from 'src/core/constants/permission-constant';
import { RoleHelper } from 'src/core/helpers/role-helper';
import { SettingsDefinitionModel } from 'src/core/models/shared/settings-definition.model';
import { FeatureService } from 'src/core/services/feature/feature.service';

@Component({
  selector: 'ca-other-setting-group',
  templateUrl: './other-setting-group.component.html',
  styleUrl: './other-setting-group.component.scss',
  standalone: false,
})
export class OtherSettingGroupComponent implements OnInit {
  activeTab: number = 1;

  isSuperAdminUser: boolean = false;
  isTenantAdminUser: boolean = false;
  externalLoginEnabled: boolean = false;
  canManageSettings: boolean = false;
  whiteLabelingEnabled: boolean = false;

  settingsDefinitionItems: SettingsDefinitionModel[] = [
    {
      label: '::Departments',
      navigationData: ['administration', 'departments'],
      extraData: null,
      requiredPolicies: [PermissionConstants.Department, PermissionConstants.SettingManagement],
      forFeatures: [],
    },
    {
      label: '::GenericLookupTypes',
      navigationData: ['administration', 'genericlookups'],
      extraData: null,
      requiredPolicies: [PermissionConstants.GenericLookup, PermissionConstants.SettingManagement],
      forFeatures: [],
    },
  ];

  constructor(
    private roleHelper: RoleHelper,
    private featureService: FeatureService,
    private permissionService: PermissionService,
    private config: ConfigStateService,
  ) {
    this.isSuperAdminUser = this.roleHelper.isSuperAdminUser();
    this.isTenantAdminUser = this.roleHelper.isTenantAdminUser();
    this.externalLoginEnabled = this.featureService.isEnabled(FeatureConstants.ExternalLogin);
    this.canManageSettings = this.permissionService.getGrantedPolicy(
      PermissionConstants.SettingManagement,
    );
    this.whiteLabelingEnabled =
      this.config.getSetting('WhiteLabeling:Enabled')?.toLowerCase() === 'true';
  }

  ngOnInit(): void {
    if (this.canManageSettings) {
      this.activeTab = 1;
    } else {
      this.activeTab = 8;
    }
  }
}
